module.exports = "/_next/static/images/paul-gilbert@2x-6c58fb16704890b7246bacbb8b7765a9.png";